import { render, staticRenderFns } from "./oper-data.vue?vue&type=template&id=a5cf5ffe"
import script from "./oper-data.vue?vue&type=script&lang=ts"
export * from "./oper-data.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports